window.OrderCutPriceUtils = {
  // Overseas store: Tax-excluded calculation
  // Metafield rates are already tax-excluded, no tax conversion needed
  calculateCustomPrice: function(params) {
    const safeParams = params || {};

    const width = Number(safeParams.width);
    const height = Number(safeParams.height);
    const quantity = Number(safeParams.quantity);
    const unitRate = Number(safeParams.unitRate);

    if (!Number.isFinite(width) || width <= 0) throw new Error('Invalid width');
    if (!Number.isFinite(height) || height <= 0) throw new Error('Invalid height');
    if (!Number.isFinite(quantity) || quantity < 1) throw new Error('Invalid quantity');
    if (!Number.isFinite(unitRate) || unitRate <= 0) throw new Error('Invalid unitRate');

    const includeBaseFee = safeParams.includeBaseFee !== false;
    const baseFee = includeBaseFee ? Number(safeParams.baseFee ?? 7000) : 0;
    const materialMargin = Number(safeParams.materialMargin ?? 3);
    const additionalMargin = Number(safeParams.additionalMargin ?? 5);
    const additionalChargeArea = Number(safeParams.additionalChargeArea ?? (600 * 300));
    const additionalChargeRate = Number(safeParams.additionalChargeRate ?? 2000);
    const cuttingFeePerUnit = Number(safeParams.cuttingFeePerUnit ?? 15);
    const roundingUnit = Number(safeParams.roundingUnit ?? 10);
    const taxRate = Number(safeParams.taxRate ?? 0); // Overseas: default no tax

    if (!Number.isFinite(baseFee) || baseFee < 0) throw new Error('Invalid baseFee');
    if (!Number.isFinite(materialMargin)) throw new Error('Invalid materialMargin');
    if (!Number.isFinite(additionalMargin)) throw new Error('Invalid additionalMargin');
    if (!Number.isFinite(additionalChargeArea) || additionalChargeArea <= 0) throw new Error('Invalid additionalChargeArea');
    if (!Number.isFinite(additionalChargeRate) || additionalChargeRate < 0) throw new Error('Invalid additionalChargeRate');
    if (!Number.isFinite(cuttingFeePerUnit) || cuttingFeePerUnit < 0) throw new Error('Invalid cuttingFeePerUnit');
    if (!Number.isFinite(roundingUnit) || roundingUnit <= 0) throw new Error('Invalid roundingUnit');
    if (!Number.isFinite(taxRate) || taxRate < 0) throw new Error('Invalid taxRate');

    const materialCost = (width + materialMargin) * (height + materialMargin) * unitRate * quantity;
    const additionalUnits = Math.ceil((width + additionalMargin) * (height + additionalMargin) * quantity / additionalChargeArea);
    const additionalFee = additionalChargeRate * additionalUnits;
    const cuttingFee = cuttingFeePerUnit * quantity;

    const rawSubtotal = baseFee + materialCost + additionalFee + cuttingFee;
    const subtotal = Math.round(rawSubtotal / roundingUnit) * roundingUnit;
    const unitPrice = Math.round(subtotal / quantity);

    const tax = Math.round(subtotal * taxRate);
    const total = subtotal + tax;

    return { unitPrice, subtotal, tax, total };
  }
};
